import React from 'react';
import SpotlightHeader from '../../Common/Header';
import BottomBar from '../../../components/BottomBar';
import './Shoutout.scss';
import { isValidString } from '../../../helpers/utils';
const CELEBRATE_IMAGE = 'https://spotlightscdn.shiftplatform.tv/assets/spotlight_creator/feedbackv2.png';
const Shoutout = props => {
  var _metadata$boh_shoutou;
  const {
    metadata,
    bohStyle,
    text
  } = props;
  const {
    accent_color,
    text_accent_color,
    containerStyle
  } = bohStyle;
  const shoutout_inputs = (_metadata$boh_shoutou = metadata.boh_shoutout_info.inputs.filter(input => isValidString(input.key) && isValidString(input.value))) !== null && _metadata$boh_shoutou !== void 0 ? _metadata$boh_shoutou : [];
  const hide_poweredbyshift = metadata.hide_poweredbyshift;
  const image = metadata.boh_shoutout_info.image;
  return /*#__PURE__*/React.createElement("div", {
    className: "shoutout-container",
    style: containerStyle
  }, /*#__PURE__*/React.createElement(SpotlightHeader, {
    text: text,
    metadata: metadata
  }), /*#__PURE__*/React.createElement("div", {
    className: "shoutout-info-container"
  }, image ? /*#__PURE__*/React.createElement("div", {
    className: "shoutout-picture-container"
  }, /*#__PURE__*/React.createElement("img", {
    className: "shoutout-picture",
    src: image,
    alt: "profile"
  })) : /*#__PURE__*/React.createElement("img", {
    className: "shoutout-celebrate",
    src: CELEBRATE_IMAGE,
    alt: "celebrate"
  }), /*#__PURE__*/React.createElement("div", {
    className: "shoutout-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shoutout-to"
  }, "Shoutout to:"), /*#__PURE__*/React.createElement("div", {
    className: "shoutout-info-title"
  }, metadata.boh_shoutout_info.title), /*#__PURE__*/React.createElement("div", {
    className: "shoutout-info-inputs"
  }, shoutout_inputs.map((i, index) => {
    return /*#__PURE__*/React.createElement("p", {
      key: `input_${index + 1}`
    }, /*#__PURE__*/React.createElement("label", null, i.key, ":", /*#__PURE__*/React.createElement("br", null)), " ", i.value, " ");
  })))), /*#__PURE__*/React.createElement(BottomBar, {
    accent_color: accent_color,
    accent_text_color: text_accent_color,
    hide_poweredbyshift: hide_poweredbyshift
  }));
};
export default Shoutout;